module.exports = __webpack_public_path__ + "static/media/up-carat.64cca3ef.svg";